"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var components_1 = require("components");
var metadata_1 = require("../libzl/metadata");
var SVGIconPadding = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: 0px;\n"], ["\n\tmargin: 0px;\n"])));
function convertTypeIdToIcon(id, svgs) {
    var prefix = "acc_icon_";
    var icon = svgs[prefix + id];
    if (icon) {
        return icon;
    }
    var stem = id.split(" ")[0].split("/")[0].split(",")[0].toLowerCase();
    if (stem.search("hsield") >= 0 || stem.search("shields") >= 0) {
        stem = "windshield";
    }
    return svgs[prefix + stem];
}
function getThumbnail(buildSession, icon, id, typeid, accCat, highlighted, renderable, fallback, noPreviewMsg, svgs, validTo, validFrom, blacklisted3D, blacklistedUI, characteristics) {
    var fallbackContent = (typeid && convertTypeIdToIcon(typeid, svgs)) || (accCat ? svgs.icon_accessories : svgs.icon_options);
    // check if date is technically forever
    if (validTo !== undefined) {
        var year = validTo.slice(0, 4);
        if (parseInt(year) >= 9999) {
            validTo = undefined;
        }
    }
    // check if the item is valid rn
    if (validFrom !== undefined) {
        var vf = Date.parse(validFrom);
        if (vf < Date.now()) {
            validFrom = undefined;
        }
    }
    var overrideThumb = metadata_1.getMiscellaneousThumb(id);
    if (overrideThumb) {
        return (react_1.default.createElement(components_1.Thumbnail, { content: overrideThumb, validTo: validTo, validFrom: validFrom, bl3d: blacklisted3D, blui: blacklistedUI, fallbackContent: fallbackContent, noPreviewMsg: noPreviewMsg, id: id, highlighted: highlighted, renderable: renderable, category: characteristics }));
    }
    if (icon) {
        return (react_1.default.createElement(components_1.Thumbnail, { content: icon, validTo: validTo, validFrom: validFrom, bl3d: blacklisted3D, blui: blacklistedUI, fallbackContent: fallbackContent, noPreviewMsg: noPreviewMsg, id: id, highlighted: highlighted, renderable: renderable, category: characteristics }));
    }
    if (!accCat) {
        if (buildSession) {
            var thumb = metadata_1.getItemThumb(buildSession, id, typeid, svgs);
            if (typeof (thumb.icon) === "string") {
                return react_1.default.createElement(components_1.Thumbnail, { content: react_1.default.createElement("img", { src: thumb.icon, alt: "" }), validTo: validTo, validFrom: validFrom, bl3d: blacklisted3D, fallbackContent: thumb.fallback, paint: true, noPreviewMsg: noPreviewMsg, id: id, highlighted: highlighted, renderable: renderable, category: characteristics });
            }
            if (thumb.icon) {
                return (react_1.default.createElement(components_1.Thumbnail, { content: react_1.default.createElement(SVGIconPadding, null, thumb.icon), validTo: validTo, validFrom: validFrom, bl3d: blacklisted3D, blui: blacklistedUI, fallbackContent: fallbackContent || thumb.fallback, noPreviewMsg: noPreviewMsg, id: id, highlighted: highlighted, renderable: renderable, category: characteristics }));
            }
            else if (thumb.fallback) {
                return (react_1.default.createElement(components_1.Thumbnail, { content: react_1.default.createElement(SVGIconPadding, null, thumb.fallback), validTo: validTo, validFrom: validFrom, bl3d: blacklisted3D, blui: blacklistedUI, fallbackContent: fallbackContent || thumb.fallback, noPreviewMsg: noPreviewMsg, id: id, highlighted: highlighted, renderable: renderable, category: characteristics }));
            }
        }
    }
    else if (typeof (id) === "string") {
        // this isn't pretty, hopefully can be nicer later.
        var icon_1 = convertTypeIdToIcon(id, svgs);
        if (icon_1) {
            return (react_1.default.createElement(components_1.Thumbnail, { content: react_1.default.createElement(SVGIconPadding, null, icon_1), validTo: validTo, validfrom: validFrom, bl3d: blacklisted3D, blui: blacklistedUI, fallbackContent: fallbackContent, noPreviewMsg: noPreviewMsg, highlighted: highlighted, renderable: renderable, category: characteristics }));
        }
    }
    if (fallback) {
        return (react_1.default.createElement(components_1.Thumbnail, { content: undefined, validTo: validTo, validfrom: validFrom, bl3d: blacklisted3D, blui: blacklistedUI, fallbackContent: fallbackContent, noPreviewMsg: noPreviewMsg, id: id, highlighted: highlighted, renderable: renderable, category: characteristics }));
    }
    return (react_1.default.createElement(components_1.Thumbnail, { content: react_1.default.createElement(SVGIconPadding, null, fallbackContent), validTo: validTo, validfrom: validFrom, bl3d: blacklisted3D, blui: blacklistedUI, noPreviewMsg: noPreviewMsg, id: id, highlighted: highlighted, renderable: renderable, category: characteristics }));
}
exports.getThumbnail = getThumbnail;
var templateObject_1;
//# sourceMappingURL=thumbnail.js.map